var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Profile_images",
    "data-name": "Profile images",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.022,
    height: 26.022,
    viewBox: "0 0 26.022 26.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M13.011,0A13.011,13.011,0,1,1,0,13.011,13.011,13.011,0,0,1,13.011,0Z",
    fill: "#898888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M0,18.423a8.955,8.955,0,0,1,6.751-7.871,5.576,5.576,0,1,1,5.039,0,8.954,8.954,0,0,1,6.751,7.871,13.01,13.01,0,0,1-18.54,0Z",
    transform: "translate(3.741 3.717)",
    fill: "#fafbfe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImages);
export default __webpack_public_path__ + "static/media/ProfileImages.40144da321c19bc1d780d30c22ad061f.svg";
export { ForwardRef as ReactComponent };